import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: true,
  data: null,
  error: null,
};

const roomControlSlice = createSlice({
  name: 'roomcontrol',
  initialState,
  reducers: {
    resetControl: () => initialState,
    setRoomControlLoading: (state, action)=>{
      state.loading = action.payload;
    },
    roomControlSuccess: (state, action) => {
        state.loading = false,
        state.data = action.payload
    },
    roomControlFailure: (state, action) => {
        state.loading = false,
        state.error = action.payload
    },

  }
});

export const { resetControl, setRoomControlLoading, roomControlSuccess, roomControlFailure  } = roomControlSlice.actions;
export default roomControlSlice.reducer;
